import el from "@cypherpotato/el";
import { throttledCall } from "../ui/throttle";
import { FormControl, TextInput } from "./form";
import { BadgeList, TagBadge } from "./badge";
import { Icon } from "./icon";

export function Image(src, ...args) {
    return el("img", { src }, ...args);
}

export function ImageModelContainer(modelData) {
    return el("div.image-model-container",
        Image(`/assets/imggenmodels/${modelData.name.replace(/^@[^/]+\//, "")}.webp`),
        el(".model-data",
            el("div.model-name", modelData.name),
            BadgeList(
                modelData.flags?.includes("AllowReferenceImage") && TagBadge("References ", Icon("ai-generate-text"), { style: { color: "rgb(54, 36, 218)" } }),
                modelData.flags?.includes("AllowMatureContent") && TagBadge("NSFW ", Icon("eye-off-line"), { style: { color: "rgb(218, 36, 139)" } }),
                modelData.flags?.includes("Deprecated") && TagBadge("Deprecated ", Icon("delete-bin-line"), { style: { color: "rgb(218, 36, 36)" } }),
            )
        )
    )
}

export function ImageContainer(src, boxSize, ...args) {

    const srcState = el.state.create(src);

    return el.state.listening([srcState], () =>
        el("div.image-container",
            Image(srcState.value ?? "", {
                style: {
                    width: (boxSize + 10) + "px",
                    height: (boxSize + 10) + "px"
                },
                onError(event) {
                    event.target.closest(".image-container").classList.add("image-error");
                },
                onLoad(event) {
                    event.target.closest(".image-container").classList.remove("image-error");
                }
            }),
            el(".image-error-message",
                srcState.value?.nullWhenEmpty() == null ? "No image was provided" : "Image could not be loaded"
            ),
            {
                $properties: {
                    src: {
                        get() {
                            return srcState.value;
                        },
                        set(value) {
                            srcState.value = value;
                        }
                    }
                }
            },
            ...args
        )
    );
}

export function ImageControl({ value, props }) {

    const srcState = el.state.create(value);

    return el(".image-control-wrapper",
        el.state.listening([srcState], () =>
            ImageContainer(srcState.value, 120)
        ),
        FormControl("Image source URL",
            TextInput(null, "https://", {
                onInput(event) {
                    throttledCall(() => {
                        srcState.value = event.target.value;
                    }, 300);
                },
                value: srcState.value
            })
        ),
        {
            $properties: {
                value: {
                    get() {
                        return srcState.value;
                    },
                    set(value) {
                        srcState.value = value;
                    }
                }
            }
        },
        props
    );
}